import * as THREE from 'three';
import { drawPolylineFromCode } from '../../commands/drawPolylineFromCode';
import { createSolidHatchFromBoundary } from '../../commands/createSolidHatchFromBoundary';
import { generateUniqueId } from '../../utils/generateUniqueId';
import { createTextSprite } from '../../utils/createTextSprite';
export function createSupplyPoint(
    scene,
    mousePos,
    text = "Panel",
    componentId
) {
  const group = new THREE.Group(); // ana grup
  // Name this group as a supply point so panel-traversal code does not treat it as a panel
  group.name = "supplyPoint"
    const panelID = componentId//generateUniqueId('panel');
    const offsetGroup = new THREE.Group(); // içerikler için offset grubu
    offsetGroup.name = "offsetGroup"
    // Panel boyutları
    const panelWidth = 25;
    const panelHeight = 25;

    const basePoint = {
        x: mousePos.x,
        y: mousePos.y,
    };
    //------------------------------
    // Ana grup tıklanan yere yerleşir
    group.position.set(basePoint.x, basePoint.y, 0);
    // offsetGroup'u sola kaydırarak panelin sol kenarını basePoint hizasına getiriyoruz
    offsetGroup.position.set(0, 0, 0);
    group.add(offsetGroup);
    const halfW = panelWidth / 2;
    const halfH = panelHeight / 2;
  const points = [
    { x: -halfW, y: -halfH },
    { x: -halfW, y: halfH },
    { x: halfW, y: halfH },
    { x: halfW, y: -halfH },
  ];
    // === 1. Polyline ===
    const polyline = drawPolylineFromCode(offsetGroup, {
        points,
        color: 0xff3333,
        closed: true,
    });

if (polyline) {
  polyline.userData = { isPanelPart: true, panelID };
  polyline.name = 'box-outer';
}
  // Polyline’ın boundary noktalarını al

  const hatchElement = {
    handle: generateUniqueId(),
    SolidFillFlag: 1,
    HatchPatternName: "SOLID",
  };

  const hatchPaths = [
    {
      type: "outer",
      groups: [
        {
          edgeType: "Line",
          x1: -halfW,
          y1: -halfH,
          x2: -halfW,
          y2: halfH
        },
        {
          edgeType: "Line",
          x1: -halfW,
          y1: halfH,
          x2: halfW,
          y2: halfH
        },
        {
          edgeType: "Line",
          x1: halfW,
          y1: halfH,
          x2: halfW,
          y2: -halfH
        }
      ]
    }
  ];
  // Solid hatch (dolgu) oluştur
   const hatch = createSolidHatchFromBoundary(hatchElement, {
    boundaryPaths: hatchPaths,
    color: 0x000000,
    
    opacity: 0.99,
    depthWrite: false,
    transparency: true,
    group: offsetGroup,
  });

     if (hatch) {
       hatch.name = 'box-hatch';
       hatch.userData = {
         ...hatch.userData,
         isPanelPart: true,
         originalColor: 0x000000,
         originalOpacity: 0.01,
         originalTransparent: true
       };

       // Manuel olarak transparency ayarlarını uygula
       if (hatch.material) {
         hatch.material.opacity = 0.01;
         hatch.material.transparent = true;
         // colorWrite=false: tıklama alanı asla boyanmaz (raycast çalışır).
         hatch.material.colorWrite = false;
         hatch.material.needsUpdate = true;
       }
     }
     offsetGroup.add(hatch);
  


  const textSprite = createTextSprite(text, {
        fontSize: 40,
        color: '#ffffff',
        backgroundColor: 'transparent',
        strokeColor: 'black',
        padding: 4,
    });

  // mark and name the label so updaters can find/update it instead of creating duplicates
  textSprite.position.set(0, 0, 0.1); // dörtgen ortasına
  textSprite.name = 'supplyLabel';
  textSprite.userData = { ...(textSprite.userData || {}), role: 'name' };
  offsetGroup.add(textSprite);
     //-------------------
     
    group.layers.set(1)
    group.userData = {
        id: panelID,
        type: 'supplyPoint',
        function: 'supplyPoint',
        // name = görünen etiket (tesisat sync bunu label olarak alır → save/load'da
        // korunur). Tip tanımlayıcı type/function alanlarında.
        name: text,
        isSelectable: true,
        isPanelPreview: true,
        originalColor: 0xffffff,
        outs: [],
        outSnaps: [],
        basePoint: { ...basePoint },
        height: panelHeight,
        startH: panelHeight / 2,
        endH: panelHeight / 2 - 5,
        details: {

        },
        salt: {
        }
    };

    if (scene) {
        scene.add(group);
    }
    return group;
}
